import React from 'react';
import { Menu } from 'antd';
import * as SN from './index.styled';
import { useNavigate, useLocation } from 'react-router-dom';
import { userAtom } from '@/recoil/atoms/user.atom';
import { useRecoilValue } from 'recoil';

interface SideNavProps {
  $collapsed: boolean;
  onToggle: () => void;
}

function SideNav({ $collapsed, onToggle }: SideNavProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const user = useRecoilValue(userAtom);

  // 현재 경로에 따라 선택된 키를 결정하는 함수
  const getSelectedKeys = () => {
    const pathMapToKey: { [key: string]: string } = {
      '/admin/dashboard': '1',
      '/admin/advertiser': '2',
      '/admin/campaign': '3',
      '/admin/log': '4',
      '/admin/report': '5',
      '/admin/rewardreport': '6',
      '/admin/user': '7',
      '/admin/campaign_product': '8',
      '/admin/offerwall': '9',
      '/admin/coupang_product': '10',
    };
    const [base, path] = location.pathname.split('/').slice(1, 3);
    const key = pathMapToKey[`/${base}/${path}`];

    return [key];
  };

  return (
    <>
      <SN.Wrapper $collapsed={$collapsed}>
        <Menu
          mode="inline"
          inlineCollapsed={$collapsed}
          selectedKeys={getSelectedKeys()}
          style={{ height: '100%', borderRight: 0 }}
        >
          {user && (user.role_name === 'admin' || user.role_name === 'super') && (
            <>
              <SN.AdminLabel>ADMIN MENU</SN.AdminLabel>
              <Menu.Item key="1" onClick={() => navigate('/admin/dashboard')}>
                대시보드
              </Menu.Item>
              <Menu.Item key="2" onClick={() => navigate('/admin/advertiser')}>
                광고주 관리
              </Menu.Item>

              <Menu.Item key="7" onClick={() => navigate('/admin/user')}>
                사용자 관리
              </Menu.Item>
              <Menu.Item key="8" onClick={() => navigate('/admin/campaign_product')}>
                상품 관리
              </Menu.Item>
              {/* 임시 숨김 (추후 다시 노출 가능성 있어 주석 처리)
              <Menu.Item key="10" onClick={() => navigate('/admin/coupang_product')}>
                쿠팡 추천 상품 관리
              </Menu.Item>
              */}
            </>
          )}
          <SN.CommonLabel>COMMON MENU</SN.CommonLabel>

          <Menu.Item key="3" onClick={() => navigate('/admin/campaign')}>
            캠페인 관리
          </Menu.Item>
          {user && (user.role_name === 'admin' || user.role_name === 'super') && (
            <Menu.Item key="9" onClick={() => navigate('/admin/offerwall')}>
              오퍼월 관리
            </Menu.Item>
          )}
          <Menu.Item key="4" onClick={() => navigate('/admin/log')}>
            로그 & 리포트 관리
          </Menu.Item>
          {user && (
            (user.role_name === 'advertiser' && user.category === 'a') ||
            user.role_name === 'admin' || user.role_name === 'super'
          ) && (
              <Menu.Item key="6" onClick={() => navigate('/admin/rewardreport')}>
                정산 관리
              </Menu.Item>
            )}

        </Menu>
      </SN.Wrapper>
      <SN.ToggleButton $collapsed={$collapsed} onClick={onToggle}>
        {$collapsed ? <SN.CustomRightSquareOutlined /> : <SN.CustomLeftSquareOutlined />}
      </SN.ToggleButton>
    </>
  );
}
export default SideNav;
